var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('flat-pickr',_vm._g(_vm._b({ref:"flatPickr",class:{
        ..._vm.customInputClasses,
        [`form-control-${_vm.size}`]: true,
    }},'flat-pickr',{
        config: {
            time_24hr: true,
            allowInput: true,
            dateFormat: _vm.mergedData['date-format'] ?? 'Y/m/d',
            enableTime: false,
            mode:
                _vm.multiple === true
                    ? 'multiple'
                    : _vm.multiple === 'range'
                      ? 'range'
                      : 'single',
        },
        ..._vm.$attrs,
        ..._vm.$props,
        value: _vm.generatedInnateValue,
    },false),{
        ..._vm.$listeners,
        // input: updateDateValue,
        'on-close': _vm.updateDateValue,
    }))
}
var staticRenderFns = []

export { render, staticRenderFns }